module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10237.5a5449ab.jpg";